import { Injectable } from '@angular/core';
import { SelectClientService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';

@Injectable({
  providedIn: 'root',
})
export class PerfilService {
  hasClient$$ = this.selectClientService.hasClient$$;
  constructor(private readonly selectClientService: SelectClientService) {}

  start() {}
}
